import React from 'react';
import PropTypes from 'prop-types';

const Clock = ({ fill, className = '' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15.52"
    height="15.52"
    viewBox="0 0 15.52 15.52"
    className={className}
  >
    <path
      d="M9.075,2.476a7.793,7.793,0,0,0,7.756-7.756,7.8,7.8,0,0,0-7.764-7.764A7.79,7.79,0,0,0,1.311-5.281,7.794,7.794,0,0,0,9.075,2.476Zm0-1.992A5.747,5.747,0,0,1,3.311-5.281a5.747,5.747,0,0,1,5.757-5.771,5.759,5.759,0,0,1,5.771,5.771A5.747,5.747,0,0,1,9.075.483ZM5.632-4.131H9.067a.719.719,0,0,0,.725-.732V-9.375a.713.713,0,0,0-.725-.725.718.718,0,0,0-.725.725v3.787H5.632a.718.718,0,0,0-.725.725A.719.719,0,0,0,5.632-4.131Z"
      transform="translate(-1.311 13.044)"
      fill={fill}
    />
  </svg>
);

Clock.propTypes = {
  fill: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default Clock;
